import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { clientApiSetting } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const clientApiSettingSlice = createSlice({
    name: clientApiSetting,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetailParams: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetailParams } = clientApiSettingSlice.actions;
export default clientApiSettingSlice.reducer;
